import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Home } from 'lucide-react';

const BackgroundImage = `${process.env.PUBLIC_URL}/bgimg.jpg`;

const Root = styled('div')(({ theme }) => ({
  background: `url(${BackgroundImage}) no-repeat fixed center center`,
  backgroundSize: 'cover',
  height: '100vh',
  width: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    background: alpha(theme.palette.grey[300], 0.77),
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  backgroundColor: alpha(theme.palette.background.paper, 0.4),
  boxShadow: 'none',
  padding: theme.spacing(8),
  maxWidth: 950,
  borderRadius: 25,
  [theme.breakpoints.down('md')]: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
}));

const ButtonContainer = styled('div')(({ theme }) => ({
  textAlign: 'center',
  paddingTop: theme.spacing(8),
}));

export const AccessDenied = (): ReactElement => {
  const { t } = useTranslation('common');
  const history = useHistory();

  const message1 = t(
    'authentication.accessDenied.message1',
    'You do not have permission to access this page.',
  );
  const message2 = t(
    'authentication.accessDenied.message2',
    'Contact an administrator to get permissions or go to the home page and browse other pages.',
  );
  return (
    <Root>
      <StyledCard>
        <CardContent>
          <Typography variant="h2" gutterBottom sx={{ mb: 8 }}>
            {t('authentication.accessDenied.title', 'Access denied')}
          </Typography>
          <Typography gutterBottom={false} sx={{ pb: 2 }} component="div">
            <p>{message1}</p>
            <p>{message2}</p>
          </Typography>
          <ButtonContainer>
            <Button
              onClick={() => history.push('/')}
              color="primary"
              variant="contained"
              size="large"
              sx={{ margin: '0 auto', fontWeight: 'bold', color: '#ffffff' }}
              startIcon={<Home />}
            >
              {t('authentication.accessDenied.backhome', 'Go to home')}
            </Button>
          </ButtonContainer>
        </CardContent>
      </StyledCard>
    </Root>
  );
};

export default AccessDenied;
